var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.authUser.account_type == 'admin' || _vm.authUser.account_type == 'worker' || _vm.authUser.account_type == 'worker-v2')?_c('div',{staticClass:"grid-container fluid mt-3"},[_c('OrderForm')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }